import { render, staticRenderFns } from "./PaymentMethodNew.vue?vue&type=template&id=7d4ef21b&scoped=true&"
import script from "./PaymentMethodNew.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ef21b",
  null
  
)

export default component.exports